export default __webpack_public_path__ + "static/media/django-plain.a51dc736.svg";